import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    message: String,
  };

  connect() {
    // console.log(
    //   `ParentPostMessageController connected with message: ${this.messageValue}`
    // );
  }

  postMessage() {
    parent.postMessage(
      { message: `redirect_to_page:${this.messageValue}` },
      "*"
    );
  }
}
